import React from "react";
import { useNavigate } from "react-router-dom";
import { Add as AddIcon } from "@mui/icons-material";
import { Button } from "@mui/material";
import { subscriptionRoutes } from "../subscription-routes";

export function SubscriptionCreateButton() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(subscriptionRoutes.add);
  };

  return (
    <Button
      id="create-subscription-button"
      onClick={handleClick}
      color="secondary"
      variant="outlined"
      startIcon={<AddIcon />}
    >
      Create Subscription
    </Button>
  );
}
